module.exports = __webpack_public_path__ + "static/media/Motorfaudbanner.831d7254.svg";